import '../../../../../styles/globals.css'
import { Box, Typography } from '@mui/material'
import React, {  } from 'react';
import { Grid } from '@mui/material';

import UsernameIconDisplay from '../UsernameIconDisplay';
import { GetSpotifyCode } from '../NoteUtils';
import LoveSectionComponent from '../LoveSectionComponent';
import NoteExpiryGridPiece from '../NoteExpiryGridPiece';
import DeleteNoteSectionComponent from '../DeleteNoteSectionComponent';


const ReactMarkdown = require('react-markdown').default;

function PlaylistFeatureNoteComponent(props) {

    return (
        <Box>
            <Grid container className='' spacing={0.5} sx={{
                width: "21.55rem",
                justifyContent: "center",
                alignItems: "center",
                padding: "0.5rem",
                margin: "0.25rem",
                backgroundColor: "rgba(221, 221, 221, 0.075)",
                borderRadius: "0.25rem",
                borderColor: "rgba(221, 221, 221, 0.25)",
                border: "1px solid rgba(221, 221, 221, 0.35)"
            }}>
                <Grid item xs={6} sm={6}>
                    <UsernameIconDisplay note={props.note} />
                </Grid>
                <DeleteNoteSectionComponent note={props.note} />
                <LoveSectionComponent note={props.note} />
                <Grid item xs={12} sm={12} sx={{ width: "100%", marginTop: "0.45rem", marginBottom: "0.5rem", justifyContent: "center", alignItems: "center" }}>
                    <ReactMarkdown linkTarget="_blank" 
                        components={{
                            p: ({ children }) => (
                                <Typography variant="body2" component="div" gutterBottom sx={{ marginBottom: "0.625rem" }}>
                                    {children}
                                    <Box sx={{ marginTop: "0.325rem" }} />
                                    {props.moodTags.map((moodTag) => {
                                        return (
                                            <strong>#{moodTag.hashTag} </strong>
                                        );
                                    })}
                                </Typography>
                            ),
                        }}
                    >
                        {props.note.isNewsletterNote ? props.note.text : "is currently feeling.."}
                    </ReactMarkdown>
                    <Box sx={{
                        width: "19.9325rem", height: "5.175rem",
                        marginTop: "1.0rem",
                        marginBottom: "0.25rem",
                        backgroundColor: "rgba(221, 221, 221, 0.075)",
                        borderRadius: "0.75rem",
                        borderColor: "rgba(221, 221, 221, 0.25)",
                        border: "1px solid rgba(221, 221, 221, 0.35)"
                    }}>
                        <iframe src={"https://open.spotify.com/embed/" + GetSpotifyCode(props.note.url) + "&theme=0"} width="100%" height="100%" frameBorder="0" allowtransparency="true" allow="encrypted-media"></iframe>
                    </Box>
                </Grid>
                <NoteExpiryGridPiece note={props.note} neverExpires={props.neverExpires} />
                <Grid item xs={6} sm={6} sx={{ textAlign: "right", paddingRight: "1rem", padding: "0.5rem" }}>
                    {
                        props.hideGenre ? <div /> :
                            <Typography variant="body2" component="div" gutterBottom sx={{ marginBottom: "0.0rem" }}>
                                genre: <strong>#alt-pop</strong>
                            </Typography>
                    }
                </Grid>
            </Grid>
        </Box>
    );
}

export default PlaylistFeatureNoteComponent;